import script from "./TressLoginModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressLoginModal.vue?vue&type=script&lang=ts&setup=true"

import "./TressLoginModal.vue?vue&type=style&index=0&id=1caf9b90&lang=scss"

const __exports__ = script;

export default __exports__